import Vue from '_lib/_vue'
import App from './index.vue'

import { HbLoading, HbList, HbEmpty, HbToast } from '@heybox-components/heybox-ui'
Vue.use(HbLoading)
Vue.use(HbList)
Vue.use(HbEmpty)
Vue.use(HbToast)

import WebpDirective from '_lib/plugin/webp-directive.js'
Vue.use(WebpDirective)

import reportPlugin from '_lib/plugin/heybox-report.js'
Vue.use(reportPlugin)

import HbIcon from '_lib/plugin/heybox-icon.js'
Vue.use(HbIcon)

const outopenProtocol = {
  protocol_type: 'openWindow',
  webview: {
    url: 'https://web.xiaoheihe.cn/activity/spring_festival_2025',
    pull: false,
    refresh: false,
    bg: 'FFE3D5',
  },
  full_screen: true,
  use_system_dark: false,
  navigation_bar: {
    title: '‎',
    right_icon: {
      enabled: true,
      protocol: {
        protocol_type: 'share',
        title: '蛇舞新春，福满乾坤，小黑盒祝大家新春快乐！',
        desc: '来小黑盒APP集卡祈福，赢3A大作！',
        share_url: 'https://web.xiaoheihe.cn/activity/spring_festival_2025',
        img_url: 'https://imgheybox.max-c.com/oa/2025/01/23/bf25703de9202236c692fb2f64f3fe7e.png',
      }
    }
  },
  status_bar: {
    style: 'light',
  }
}
import HeyboxShare from '_lib/plugin/heybox-share';
Vue.use(HeyboxShare, {
  'open-app': {
    protocol: outopenProtocol,
    weixinShareConfig: {
      title: '蛇舞新春，福满乾坤，小黑盒祝大家新春快乐！',
      desc: '来小黑盒APP集卡祈福，赢3A大作！',
      link: window.location.href,
      imgUrl: 'https://imgheybox.max-c.com/oa/2025/01/23/bf25703de9202236c692fb2f64f3fe7e.png',
    }
  },
  'share-header': {
    title: '蛇舞新春，福满乾坤，小黑盒祝大家新春快乐！',
    desc: '来小黑盒APP集卡祈福，赢3A大作！',
    logoImg: 'https://cdn.max-c.com/heybox/logo/app_251.png',
    btnDesc: '点击下载',
    opacity: 0.9,
    useFixed: true,
  }
})


new Vue({
  render: h => h(App),
}).$mount('#app')
